// extracted by mini-css-extract-plugin
module.exports = {"shippingWrapperContainer":"shipping-wrapper_shippingWrapperContainer__EXkv5"};